import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import VerticalTabs from '../../../components/tabs/verticalTabs';
import { HubspotIntegrationsTabLinks } from '../../../components/enums/tabEnums';
import { CustomButton } from '../../../components/buttons/customButton';
import { hubspotIntegrationUrl } from '../../../constants/integrationConstants';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';

const HubSpotPanel = () => {
  const location = useLocation();
  const currentTab = location.pathname.split('/')
    .pop();
  const activePanel = HubspotIntegrationsTabLinks[currentTab as keyof typeof HubspotIntegrationsTabLinks] || 0;
  const { t } = useTranslation();
  const organizationSettings = useOrganizationSettingsStore((state) => state.organizationSettings);

  if (organizationSettings?.isConnectedToHubspot) {
    return (
      <div className="-ml-6 -mt-6 flex h-full w-[calc(100%+48px)] ">
        <VerticalTabs
          currentTab={activePanel}
          tabs={[
            {
              tabLabel: t('forms') || 'Forms',
              href: 'forms',
              identifierName: 'forms-panel',
            }, {
              tabLabel: t('dealSettings') || 'Deal Settings',
              href: 'deal-settings',
              identifierName: 'deal-settings-panel',
            }, {
              tabLabel: t('contactSettings') || 'Contact Settings',
              href: 'contact-settings',
              identifierName: 'contact-settings-panel',
            },
          ]}
        />
      </div>
    );
  }

  return (
    <div className="flex justify-between gap-5 rounded-xl border p-4">
      <div className="flex flex-col gap-2 text-primary">
        <span className="text-sm font-semibold">Connect to HubSpot</span>
        <p className="text-sm font-normal">
          Here you can link your HubSpot account with our platform for more efficient tracking.
        </p>
      </div>
      <CustomButton
        loading
        type="button"
        onClick={() => window.location.replace(hubspotIntegrationUrl)}
      >
        {t('connectToHubspot')}
      </CustomButton>
    </div>
  );
};

export default HubSpotPanel;
